import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config";
import "../../Pages/css/signup.css";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  Nav,
} from "react-bootstrap";
import { userSignup, userlogin } from "../../../services/apiServices";

import * as Yup from "yup";
import { Formik } from "formik";
import { Spin } from "antd";
import { ERROR, Success, Warning } from "../../../utils/errors";
import { useDispatch, useSelector } from "react-redux";
import * as ACTIONTYPES from "../../../redux/actionTypes";
import { useDisconnect } from "wagmi";
import { FaRegEye } from "react-icons/fa";
// import Connectwalletsecond from "../../Pages/Presale/Connectwallet";
import Connectwallet from "../../Pages/Presale/Connectwallet/index";

const LoadingPopup = () => {
  return (
    <div className="loading-popup-container">
      <div className="loading-popup">
        <p>Please wait</p>
        <h1>Loggin in . . .</h1>
      </div>
    </div>
  );
};

const UserSignup = () => {
  const dispatch = useDispatch();
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const [WalletAddress, setWalletAddress] = useState("");
  const [showpass,setshowpass] = useState(false);

  useEffect(() => {
    if (walletConnnected) {
      setconnectWalletNow(false);
    }
    setWalletAddress(walletConnnected);
  }, [walletConnnected]);

  const _useDisconnect = useDisconnect();
  const navigate = useNavigate();
  const [showLoading, setShowLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formLoad, setFormLoad] = useState(true);
  const [passwordicon, setPasswordicon] = useState(0);
  const [connectWalletNow, setconnectWalletNow] = useState(false);
  const [show, setShow] = useState(false);
  const loginDetails = useSelector((state) => state.auth.LoginDetails);

  const disconnectWallet = () => {
    _useDisconnect.disconnect();
    dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
  };


  const showPassword = (e)=>{
    e.preventDefault();
    setshowpass(!showpass)
  }

  const handleClose = () => {
    setShow(false);
    // if (props?.setconnectWalletNow) {
    //   props?.setconnectWalletNow(false)
    // }
  };

  const showconfirmPassword = async (id) => {
    if (id === 0) {
      setPasswordicon(1);
    } else if (id === 1) {
      setPasswordicon(0);
    }
  };

  const connectWallet = async () => {
    setconnectWalletNow(true);
    setShow(true);
  };
  const submitForm = async (values) => {
    // values.preventDefault();
    console.log(values);
    if (!WalletAddress) {
      Warning("Please connect your wallet for complete registration process");
      return;
    }
    if (!values.agree) {
      Warning("To register you must agree to the Privacy Policy");
      return;
    }
    setShowLoading(true);

    const payload = {
      firstName: values.firstName,
      lastName: values.lastName,
      emailAddress: values.userName,
      password: values.password,
      walletAddress: WalletAddress,
    };
    try {
      const { data: response } = await userSignup(payload);
      console.log('signup',response)
      setShowLoading(false);
      if (response.status) {
      //  window.location.reload()
        // dispatch({ type: ACTIONTYPES.USERLOGIN, payload: response.data, token: response?.data?.authToken, isLogin: true });
        // localStorage.setItem("loginData", "");
        Success(response.message);
      //  navigate(`${config.baseurl}verifyemail`);
      } else {
        Warning(response.message);
      }
    } catch (error) {
      setShowLoading(false);
      console.log("error", error);
      ERROR("Something went wrong, Please try again.");
    }
  };

  return (
    <>
      {/* <Header
        connectWalletNow={connectWalletNow}
        setconnectWalletNow={setconnectWalletNow}
      /> */}
      {/* <Connectwalletsecond
              show={show1}
              onHide={handleClose}
              loginDetails={loginDetails}
              // connectWalletNow={connectWalletNow}
              // setconnectWalletNow={setconnectWalletNow}
            /> */}

      <Connectwallet
        show={show}
        onHide={handleClose}
        loginDetails={loginDetails}
      />

      <section className="signup-section">
        <div className="login-container">
          <Container fluid className="px-0">
            <Row className="justify-content-center">
              <Col lg={12}>
                <Row className="">
                  <Col lg={6} md={6} xs={12} className="">
                    <div className="login-form d-lg-block d-md-block d-none">
                      <div className="">
                        <img
                          src="assets/images/coinanimation3.png"
                          alt="logo"
                          className="coinsbackImg"
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} md={6} xs={12} className="mb-3">
                    <Spin spinning={showLoading}>
                      <div className="loginDiv">
                        <Row className="vh-100 align-items-center">
                          <Col lg={9} className="mx-auto">
                            <div className="form_content">
                              <div className="formDiv py-4">
                                <div className="text-center formheadbox">
                                  <h1 className="text-primary mb-2">
                                    Get Started
                                  </h1>
                                  <p className="">
                                    Already have an account?{" "}
                                    <Link
                                      className="colorcode1 text-decoration-none"
                                      to={`${config.baseurl}login`}
                                    >
                                      Login
                                    </Link>
                                  </p>
                                  {/* <Button variant='default' className='px-4 bg-transparent border border-secondary'><Google className="me-2" />&nbsp;&nbsp;Sign up with Google</Button> */}
                                  {/* <div className='mb-4 pt-2'>
                                                                            <Row>
                                                                                <Col lg={7} className='mx-auto'>
                                                                                    <Button variant="" type="button" className='googlebtn2 px-5 py-2'>
                                                                                        <img
                                                                                            src="assets/icons/GoogleIcon.svg"
                                                                                            alt=" GoogleIcon"
                                                                                            className=" Googleicon me-3" style={{ width: "35px", height: "35px" }}
                                                                                        />
                                                                                        <span>Sign up with Google</span>
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>
                                                                        </div> */}
                                  <div className="linetext mt-3 mb-3">Or</div>
                                  <div className="px-3">
                                    <h3 className="text-gradient">
                                      <b>
                                        {!WalletAddress
                                          ? "CONNECT WALLET"
                                          : "CONNECTED WALLET"}
                                      </b>
                                    </h3>
                                    {WalletAddress && (
                                      <small className="mb-0 text-break">
                                        {WalletAddress}
                                      </small>
                                    )}
                                    <div className=" mt-4 mb-4 px-2">
                                      {!WalletAddress && (
                                        <Button
                                          variant="custombtn2"
                                          className="py-2 w-100 fw-bold"
                                          onClick={connectWallet}
                                        >
                                          <b>Connect Wallet</b>
                                        </Button>
                                      )}
                                      {WalletAddress && (
                                        <Button
                                          onClick={disconnectWallet}
                                          variant="custombtn2"
                                          className="py-2 w-100 fw-bold"
                                        >
                                          <b>Disconnect</b>
                                        </Button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <Formik
                                  initialValues={{
                                    firstName: "",
                                    lastName: "",
                                    userName: "",
                                    password: "",
                                  }}
                                  validationSchema={Yup.object().shape({
                                    userName: Yup.string()
                                      .nullable()
                                      .required("Please enter email"),
                                    firstName: Yup.string()
                                      .nullable()
                                      .required("Please enter first name"),
                                    lastName: Yup.string()
                                      .nullable()
                                      .required("Please enter last name"),
                                    password: Yup.string()
                                      .required("Please enter password")
                                      .matches(
                                        /\b([A-Z])/g,
                                        "Password requires first letter capital"
                                      )
                                      .max(
                                        15,
                                        "Password is too long - should be maximum 15 chars."
                                      )
                                      .min(
                                        8,
                                        "Password is too short - should be 8 chars minimum."
                                      )
                                      .matches(
                                        /[0-9]/,
                                        "Password requires a number"
                                      )
                                      .matches(
                                        /[a-z]/,
                                        "Password requires a lowercase letter"
                                      )
                                      .matches(
                                        /[A-Z]/,
                                        "Password requires an uppercase letter"
                                      )
                                      .matches(
                                        /[^\w]/,
                                        "Password requires a special chars"
                                      ),
                                  })}
                                  onSubmit={(values) => {
                                    submitForm(values);
                                  }}
                                >
                                  {({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    touched,
                                    values,
                                  }) => (
                                    <Form
                                      className="forms px-4"
                                      onSubmit={handleSubmit}
                                    >
                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="First Name"
                                            aria-label="firstName"
                                            aria-describedby="basic-addon1"
                                            error={Boolean(errors.firstName)}
                                            helperText={errors.firstName}
                                            name="firstName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.firstName}
                                            className="py-2"
                                          />
                                        </InputGroup>
                                        {errors.firstName &&
                                          touched.firstName && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.firstName}
                                            </small>
                                          )}
                                      </div>
                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="Last Name"
                                            aria-label="lastName"
                                            aria-describedby="basic-addon1"
                                            error={Boolean(errors.lastName)}
                                            helperText={errors.lastName}
                                            name="lastName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.lastName}
                                            className="py-2"
                                          />
                                        </InputGroup>
                                        {errors.lastName &&
                                          touched.lastName && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.lastName}
                                            </small>
                                          )}
                                      </div>

                                      <div className="mb-3">
                                        <InputGroup className=" theme-input">
                                          <Form.Control
                                            placeholder="Email ID"
                                            aria-label="Username"
                                            aria-describedby="basic-addon1"
                                            error={Boolean(errors.userName)}
                                            helperText={errors.userName}
                                            name="userName"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.userName}
                                            className="py-2"
                                          />
                                        </InputGroup>
                                        {errors.userName &&
                                          touched.userName && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.userName}
                                            </small>
                                          )}
                                      </div>
                                      <div className="mb-3">
                                        <div className="input-field fieldbox px-0">
                                          <InputGroup className=" theme-input">
                                            <Form.Control
                                              type={`${
                                                showpass ? "name" : "password"
                                              }`}
                                              placeholder="Password"
                                              aria-label="Password"
                                              aria-describedby="basic-addon1"
                                              error={Boolean(errors.password)}
                                              helperText={errors.password}
                                              name="password"
                                              onBlur={handleBlur}
                                              onChange={handleChange}
                                              value={values.password}
                                              className="py-2"
                                            />
                                          </InputGroup>
                                          <span
                                            className="me-3"
                                            onClick={showPassword}
                                          >
                                            <FaRegEye className="eyeIcon" />
                                          </span>
                                          {/* <span onClick={passwordicon === 0 ? (e) => showconfirmPassword(0) : (e) => showconfirmPassword(1)} className='eye-show-login'>
                                                                        {passwordicon === 0 ? <img height={15} src='icons/fa-fa-eye.png' /> : <img height={15} src='icons/fa fa-eye slash.png' />}</span> */}
                                        </div>
                                        {errors.password &&
                                          touched.password && (
                                            <small
                                              className="required"
                                              style={{ color: "red" }}
                                            >
                                              {errors.password}
                                            </small>
                                          )}
                                      </div>
                                      {/* <Form.Group className="agree-me">
                                                                                    <Form.Check
                                                                                        type='checkbox'
                                                                                        id='default-checkbox'
                                                                                        label='By signing up, I agree to the Privacy Policy and Terms of Service'
                                                                                        name="agree"
                                                                                        checked={values.agree}
                                                                                        onBlur={handleBlur}
                                                                                        onChange={handleChange}
                                                                                        value={values.agree} className='text-primary'
                                                                                    />
                                                                                   
                                                                                </Form.Group> */}

                                      <Form.Group
                                        className="mb-4 checkbox"
                                        controlId="formBasicPassword"
                                      >
                                        <p className="comment-form-cookies-consent">
                                          <input
                                            id="default-checkbox"
                                            name="agree"
                                            type="checkbox"
                                            checked={values.agree}
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.agree}
                                          />
                                          <label htmlFor="wp-comment-cookies-consent">
                                            By signing up, I agree to the{" "}
                                            <a href="../PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                                            and {" "}
                                            <a href="../Terms&Conditions.pdf" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                                          </label>
                                        </p>
                                      </Form.Group>
                                      <div className="submit-btn mt-4">
                                        <Button
                                          type="submit"
                                          variant="custombtn2"
                                          className="py-2 w-100 fw-bold"
                                        >
                                          Register Now
                                        </Button>
                                      </div>
                                    </Form>
                                  )}
                                </Formik>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Spin>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <hr className="mb-0" />
      {/* <Footer /> */}
      {/* <LoadingPopup /> */}
    </>
  );
};

export default UserSignup;
